//======================================================//
//                                                      //
//                          IMPORT                      //
//                                                      //
//======================================================//
const firebase = require("firebase/app");
require("firebase/auth");
require("firebase/firestore");
require("firebase/storage");



//======================================================//
//                                                      //
//                          INIT                        //
//                                                      //
//======================================================//
const firebaseApp = firebase.initializeApp({
    apiKey: "AIzaSyCaCxfEQxl0Vsnl73xgeWxizgeLt9r70T4",
    authDomain: "products-fc60e.firebaseapp.com",
    databaseURL: "https://products-fc60e.firebaseio.com",
    projectId: "products-fc60e",
    storageBucket: "products-fc60e.appspot.com",
    messagingSenderId: "591883674797",
    appId: "1:591883674797:web:2d75d757b108d4432c1224",
    measurementId: "G-6M4XBCTX5X"})

//--------------------- UTILS ----------------------//
const db = firebaseApp.firestore();
const auth = firebaseApp.auth();
const storage = firebaseApp.storage();
const functions = firebase.functions();
var fieldVal = firebase.firestore.FieldValue;


//-------------------- UPDATES ---------------------//
const  settings = {
// timestampsInSnapshots: true
}
db.settings(settings);



//======================================================//
//                                                      //
//                          SETTER                      //
//                                                      //
//======================================================//
function setDoc(path, doc, docID, vue, notiStart, notiDone){
    var notiStart = notiStart ;
    var notiDone = notiDone;
    var docID = docID || db.collection(path).doc().id;

    doc.ID = docID;
    doc["Date Created"] = new Date().getTime();
    doc["seqSortBaby69"] = 1000;

    if (notiStart != undefined){
        vue.$toasted.show(notiStart, { 
            theme: "outline", 
            position: "top-right", 
            className: ['yellowBG'],
            duration : 5000
        });
    }
    return db.collection(path).doc(docID).set(doc).then(() =>{
        if (notiDone != undefined){
            vue.$toasted.show(notiDone, { 
                theme: "outline", 
                position: "top-right", 
                className: ['greenBG'],
                duration : 5000
            });
        }
        console.log("Setting " + docID + " at " + path + " was succcessful.");
    }).catch(err=>{
        console.log(err.message);
    })
};



//======================================================//
//                                                      //
//                          UPDATER                     //
//                                                      //
//======================================================//
//------------------------ DOCUMENT --------------------//
function updateDoc(path,  docUpdate, docID, vue, notiStart, notiDone){
    var notiStart = notiStart;
    var notiDone = notiDone;
    var docID = docID || "";
    var docUpdate = docUpdate || {};

    if (notiStart != undefined){
        vue.$toasted.show(notiStart, { 
            theme: "outline", 
            position: "top-right", 
            className: ['yellowBG'],
            duration : 5000
        });
    }

    return db.collection(path).doc(docID).update(docUpdate).then(() =>{
        if (notiDone != undefined){
            vue.$toasted.show(notiDone, { 
                theme: "outline", 
                position: "top-right", 
                className: ['greenBG'],
                duration : 5000
            });
        }
        console.log("Updating " + docID + " at " + path + " succcessful.");
    }).catch(err=>{
        console.log(err.message);
    })
};
function deleteDoc(path, docID, vue, notiStart, notiDone){
    var notiStart = notiStart || "Deleting...";
    var notiDone = notiDone || "Deleted!";
    var docID = docID || "";

    if (notiStart != undefined){
        vue.$toasted.show(notiStart, { 
            theme: "outline", 
            position: "top-right", 
            className: ['yellowBG'],
            duration : 5000
        });
    }
    return db.collection(path).doc(docID).delete().then(() =>{
        if (notiDone != undefined){
            vue.$toasted.show(notiDone, { 
                theme: "outline", 
                position: "top-right", 
                className: ['greenBG'],
                duration : 5000
            });
        }
        console.log("Deleting " + docID + " at " + path + " succcessful.");
    }).catch(err=>{
        console.log(err.message);
    })
}


//======================================================//
//                                                      //
//                          GETTER                      //
//                                                      //
//======================================================//
//------------------------ DOCUMENT --------------------//
function getDoc(path, docID){
    return db.collection(path).doc(docID);
}
//----------------------- COLLECTION -------------------//
function getCol(path){
    return db.collection(path);
}


//======================================================//
//                                                      //
//                      EXPORT                          //
//                                                      //
//======================================================//
export default{
    db,
    auth,
    storage,
    setDoc,
    updateDoc,
    deleteDoc,
    getDoc,
    getCol,
    fieldVal,
    functions
}




// WEBPACK FOOTER //
// ./src/firebase-config.js